module.exports = __webpack_public_path__ + "static/media/instagram-thin.8e0a5da8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/instagram-thin.svg
// module id = 171
// module chunks = 0